export default __webpack_public_path__ + "static/media/Samsung Galaxy Note Pro 12.2.7a10f346.png";